export function getParams(state) {
    return state.params;
}

export function linesList(state) {
    return state.linesList;
}


// WEBPACK FOOTER //
// ./src/modules/lines/getters.js